import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ClerkProvider, SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react'
import Sidebar from './components/Sidebar'
import TopNav from './components/TopNav'
import Articles from './pages/Articles'
import Media from './pages/Media'
import Redirects from './pages/Redirects'
import Flags from './pages/Flags'
import Login from './pages/Login'
import SignUp from './pages/SignUp'
import AdminGuard from './components/AdminGuard'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

export default function App() {
  if (!clerkPubKey) {
    return <div>Missing Clerk Publishable Key</div>
  }

  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <BrowserRouter>
        <SignedOut>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="*" element={<RedirectToSignIn />} />
          </Routes>
        </SignedOut>

        <SignedIn>
          <AdminGuard>
            <div className="app-shell">
              <Sidebar />

              <div className="main-content">
                <TopNav />

                <main className="page-body">
                  <Routes>
                    <Route path="/" element={<Navigate to="/articles" replace />} />
                    <Route path="/articles/*" element={<Articles />} />
                    <Route path="/media" element={<Media />} />
                    <Route path="/redirects" element={<Redirects />} />
                    <Route path="/flags" element={<Flags />} />
                    <Route path="/login" element={<Navigate to="/" replace />} />
                    <Route path="/sign-up" element={<Navigate to="/" replace />} />
                    <Route
                      path="*"
                      element={
                        <div className="empty-state" style={{ height: '60vh' }}>
                          <div className="empty-state-icon">🌀</div>
                          <h2>404 — Page not found</h2>
                          <p>This route doesn't exist in the admin dashboard.</p>
                        </div>
                      }
                    />
                  </Routes>
                </main>
              </div>
            </div>
          </AdminGuard>
        </SignedIn>
      </BrowserRouter>
    </ClerkProvider>
  )
}
